import React, { Component } from "react";
import { Container, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { HomeReusableButton } from "../../superAdminReusable/superAdminHomeButton/HomeReusableButton";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { version } from "../../../../config/Keys";
export class SuperAdminMainHomeComponent extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="super admin home" />
              <div className="super-admin-inside-right-side-panel">
                <Container fluid className="super-admin-home-panel">
                  {/* <Row>
                    <div className="w-100 d-flex justify-content-between">
                      <HomeReusableButton
                        navigationLink="/superadminallusers"
                        //superadminallusers
                        imageSrc={require("../../../../assets/images/superadmin/users.png")}
                        imageText="users"
                        imageClass="image-box image-boxone"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminallvendors"
                        imageSrc={require("../../../../assets/images/superadmin/vendors.png")}
                        imageText="vendors"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/seating.png")}
                        imageText="Seating Dashboard"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminreports"
                        imageSrc={require("../../../../assets/images/superadmin/reports.png")}
                        imageText="Reports"
                        imageClass="image-box"
                      />

                      <HomeReusableButton
                        navigationLink="/superadminiconlist"
                        imageSrc={require("../../../../assets/images/superadmin/listIcon.png")}
                        imageText="Category and Icons"
                        imageClass="image-box"
                      />
                    </div>
                  </Row>
                  <Row>
                    <div className="w-100 d-flex justify-content-between">
                      <HomeReusableButton
                        navigationLink="/superadminallpendingvendors"
                        imageSrc={require("../../../../assets/images/superadmin/vendors.png")}
                        imageText="Pending Vendors"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminratingreviews"
                        imageSrc={require("../../../../assets/images/superadmin/ratingReview.png")}
                        imageText="Ratings and Reviews with Likes/Comment"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminnomination"
                        imageSrc={require("../../../../assets/images/superadmin/nomination.png")}
                        imageText="Nominations"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminsuggestion"
                        imageSrc={require("../../../../assets/images/superadmin/suggestions.png")}
                        imageText="Suggestions And Requests"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/openissuesusers"
                        imageSrc={require("../../../../assets/images/superadmin/issuesusers.png")}
                        imageText="Open Tickets - Users"
                        imageClass="image-box"
                      />
                    </div>
                  </Row>
                  <Row>
                    <div className="w-100 d-flex justify-content-between">
                      <HomeReusableButton
                        navigationLink="/superadminoffers"
                        imageSrc={require("../../../../assets/images/superadmin/marketing.png")}
                        imageText="Super Admin (Offers)"
                        imageClass="image-box image-boxtwo"
                      />
                      <HomeReusableButton
                        navigationLink="/openissuesvendors"
                        imageSrc={require("../../../../assets/images/superadmin/issuesusers.png")}
                        imageText="Open Issues - Vendors"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadminuserfavorite"
                        imageSrc={require("../../../../assets/images/superadmin/favorites.png")}
                        imageText="User Favorites"
                        imageClass="image-box image-boxtwo"
                      />

                      <HomeReusableButton
                        navigationLink="/superadminuserviewactivity"
                        imageSrc={require("../../../../assets/images/superadmin/favorites.png")}
                        imageText="User View / Used Activity"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/restaurantadminoffers"
                        imageSrc={require("../../../../assets/images/superadmin/marketing.png")}
                        imageText="Restaurant Admin (Offers and Events)"
                        imageClass="image-box image-boxtwo"
                      />
                    </div>
                  </Row>
                  <Row>
                    <div className="bottom-button-box-width d-flex justify-content-between">
                      <HomeReusableButton
                        navigationLink="/superadminreferralcode"
                        imageSrc={require("../../../../assets/images/superadmin/referralCode.png")}
                        imageText="Referral Codes"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmin-role-management"
                        imageSrc={require("../../../../assets/images/superadmin/roles.png")}
                        imageText="Roles and Authorization"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/subadmin.png")}
                        imageText="Sub Admins"
                        imageClass="image-box"
                      />
                    </div>
                  </Row>
                  <Row> 
                    <div
                      className="d-flex justify-content-between"
                      style={{ width: "79%" }}
                    >
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/chat.svg")}
                        imageText="Chat"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/notification.png")}
                        imageText="Push Notifications"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/email.png")}
                        imageText="Emails"
                        imageClass="image-box"
                      />
                      <HomeReusableButton
                        navigationLink="/superadmindashboard"
                        imageSrc={require("../../../../assets/images/superadmin/sms.png")}
                        imageText="SMS"
                        imageClass="image-box"
                      />
                    </div>
                  </Row> */}
                  <div
                    style={{ textAlign: "center" }}
                  >{`Welcome to Admin Portal v${version}`}</div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SuperAdminMainHomeComponent;
